import { visitorLogout } from "action/auth";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

function MainLayout({ children }) {
  const { notify } = useContext(NotificationContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    const res = await visitorLogout({ searchType: "logout" });
    if (res?.code === 200) {
      navigate("/logout")
    } else {
      const message = Array.isArray(res?.message)
        ? res?.message[0]?.Msg
        : res?.message || "Something went wrong";
      notify("danger", message);
    }
  }
  return (
    <>
      <div className="sv-header print-header">
        <div className="sv-header-left">
          <div className="d-flex flex-column align-items-center">
            <img
              src={require("assets/img/brand/rpg-logo.png")}
              className="sv-logo pointer"
              alt="Raychem Logo"
              onClick={() => navigate("/")}
            />
            {/* <img
            alt="tagline"
            src={require("assets/img/brand/tagline.png")}
            className="sv-tagline"
          /> */}
          </div>
          <div className="sv-divider"></div>
          <span className="sv-header-subtitle">Jointer Verification Portal</span>
        </div>
        <Button color="link" className="svp-back" onClick={handleLogout}>
          <i className="fa-solid fa-arrow-right-from-bracket mr-2" />Logout
        </Button>
      </div>
      {children}
      <div className="sv-footer">
        <div className="sv-footer-content">
          <p className="p-0 m-0">
            © {new Date().getFullYear()} Raychem RPG Pvt. Ltd. All rights
            reserved.
          </p>
          <p className="sv-footer-links p-0 m-0">
            <span
              className="mr-3 pointer"
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </span>
            |
            <span
              className="ml-3 pointer"
              onClick={() => navigate("/terms-of-service")}
            >
              Terms & Conditions
            </span>
            {/* |
              <span className="ml-3" onClick={() => navigate("/terms-of-service")}>
                Contact Support
              </span> */}
          </p>
        </div>
      </div>

      <div className="print-only authorized-section">
        <div className="authorized-box">
          <p className="authorized-title">Authorized By</p>

          {/* <div className="authorized-signature" /> */}

          {/* <p className="authorized-signature">
            Signature: <span className="authorizes-space"></span>
          </p>
          <p className="authorized-name">
            Name: <span className="authorizes-space"></span>
          </p>
          <p className="authorized-designation">
            Designation: <span className="authorizes-space"></span>
          </p> */}

          <p className="authorized-row">
            <span className="authorized-label">Signature:</span>
            <span className="authorized-line"></span>
          </p>

          <p className="authorized-row">
            <span className="authorized-label">Name:</span>
            <span className="authorized-line"></span>
          </p>

          <p className="authorized-row">
            <span className="authorized-label">Designation:</span>
            <span className="authorized-line"></span>
          </p>
        </div>
      </div>

      <div class="print-only print-footer">
        <div>Raychem RPG Pvt. Ltd. | www.raychemrpg.com</div>
        <div>This is a system-generated verification document.</div>
      </div>
    </>
  );
}

export default MainLayout;
